import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { useGetPaymentsQuery } from "../../store/services/home/home";
import PAGES from "../../constants/pages";
import NoResult from "./NoResult";
import { debounce } from "../../utils/common";

export default function Payments() {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const [environment, setEnvironment] = useState("");

  const { data: paymentsData, status } = useGetPaymentsQuery({
    offset: currentPage === 0 ? 0 : currentPage - 1,
    limit: rowsPerPage,
    search,
    environment,
  });

  const isLoaded = status !== "pending";

  useEffect(() => {
    if (paymentsData?.body?.totalCount !== undefined) {
      setTotalRows(paymentsData.body.totalCount);
    }
  }, [paymentsData]);

  const columns = [
    {
      name: "User",
      selector: (row) => row.user_name,
      wrap: true,
      cell: (row) => (
        <div>
          <div>{row.user_name || "-"}</div>
          <small>{row.user_email || row.user_phone || ""}</small>
        </div>
      ),
    },
    {
      name: "Plan",
      selector: (row) => row.plan_name,
    },
    {
      name: "Amount",
      selector: (row) => row.price,
      cell: (row) => (row.price ? `$${row.price}` : "-"),
    },
    {
      name: "Store",
      selector: (row) => row.platform,
      cell: (row) => row.platform || "-",
    },
    {
      name: "Environment",
      selector: (row) => row.environment,
      cell: (row) => (
        <span
          className={
            (row.environment === "sandbox" ? "Inactive" : "Active") + " badge"
          }
        >
          {row.environment || "unknown"}
        </span>
      ),
    },
    {
      name: "Purchased",
      selector: (row) => row.purchase_display,
      cell: (row) =>
        row.purchase_display
          ? String(row.purchase_display).split(" ")[0]
          : row.createdAt
          ? new Date(row.createdAt).toLocaleDateString()
          : "-",
    },
    {
      name: "Expires",
      selector: (row) => row.expires_display,
      cell: (row) =>
        row.expires_display
          ? String(row.expires_display).split(" ")[0]
          : "-",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={
            (row.status === "active" ? "Active" : "Inactive") + " badge"
          }
        >
          {row.status || "-"}
        </span>
      ),
    },
    {
      name: "User Sub",
      selector: (row) => row.user_subscribed,
    },
    {
      name: "Action",
      cell: (row) => (
        <Link
          className="btnview"
          to={PAGES.viewPayment}
          state={{ id: row.user_id, data: row }}
        >
          <Icon icon="tabler:eye"></Icon>
        </Link>
      ),
    },
  ];

  const debouncedSearch = React.useCallback(
    debounce((e) => {
      setSearch(e.target.value);
      setCurrentPage(0);
    }, 300),
    []
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
              <h5>Payments</h5>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-end gap-2 mb-3">
                <select
                  className="searchfield"
                  value={environment}
                  onChange={(e) => {
                    setEnvironment(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="">All environments</option>
                  <option value="sandbox">Sandbox</option>
                  <option value="production">Live</option>
                </select>
                <input
                  type="text"
                  placeholder="Search user, email, plan..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => {
                    debouncedSearch(e);
                    setSearchText(e.target.value);
                  }}
                />
              </div>
              {paymentsData?.body?.payments?.length ? (
                <DataTable
                  columns={columns}
                  data={paymentsData.body.payments}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={(newPerPage, page) => {
                    setRowsPerPage(newPerPage);
                    setCurrentPage(page);
                  }}
                  onChangePage={(page) => setCurrentPage(page)}
                  responsive
                  className="custom-table"
                />
              ) : (
                <div>
                  {!isLoaded ? (
                    <div className="loading-state-changed">
                      <div className="loading"></div>
                    </div>
                  ) : (
                    <NoResult />
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}
